// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".workspace-sub-menu {\n  min-width: 210px;\n  padding: 6px;\n  border: 1px solid var(--portal-border);\n  border-radius: var(--brand-surface-radius, 14px) !important;\n  background-color: var(--portal-surface);\n  box-shadow: 0 16px 42px rgba(16, 17, 15, 0.18) !important;\n}\n.settings-sub-menu {\n  display: grid;\n  gap: 2px;\n}", ""]);
// Exports
module.exports = exports;
